import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12.0.3/+esm';
import { Navigation, Pagination, Autoplay, EffectFade, Grid } from 'https://cdn.jsdelivr.net/npm/swiper@12.0.2/modules/+esm';
import { Component } from "@theme/component";

export class SliderComponent extends Component {
    /**@type {Swiper|null} */
    slider = null;

    connectedCallback() {
        super.connectedCallback();
        this.#init();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

    #init() {
        if (! this.classList.contains('swiper')) {
            this.classList.add('swiper');
        }

        this.slider = new Swiper(this, {
            ...this.config,
            modules: [
                Navigation,
                Pagination,
                Autoplay,
                EffectFade,
                Grid
            ]
        });
    }

    /**@returns {object} */
    get config() {
        /**@type {any} */
        let value = {
            loop: this.dataset.loop == 'true' ? true : false,
            slidesPerView: Number(this.dataset.slidesPerView),
            slidesPerGroup: Number(this.dataset.slidesPerView),
            spaceBetween: Number(this.dataset.spaceBetween),
            effect: this.dataset.effect,
            autoplay: false,
            pagination: false,
            on: {
                init: () => {
                    this.style.opacity = '1';
                }
            }
        };

        if (this.dataset.autoplay == 'true') {
            value = {
                ...value,
                autoplay: { delay: Number(this.dataset.autoplayDelay) }
            }
        }

        if (this.dataset.pagination != '') {
            value = {
                ...value,
                pagination: {
                    el: this.dataset.pagination,
                    clickable: this.dataset.paginationClickable == 'true' ? true : false
                }
            }
        }

        if (this.dataset.navigationEnabled == 'true') {
            value = {
                ...value,
                navigation: {
                    prevEl: this.dataset.navigationPrevEl,
                    nextEl: this.dataset.navigationNextEl
                }
            }
        }

        if (this.dataset.responsive == 'true') {
            const responsive = {
                slidesPerView: Number(this.dataset.responsiveSmallSlidesPerView),
                slidesPerGroup: Number(this.dataset.responsiveSmallSlidesPerView),
                spaceBetween: this.dataset.responsiveSmallSpaceBetween,
                breakpoints: {
                    750: {
                        slidesPerView: Number(this.dataset.responsiveMediumSlidesPerView),
                        slidesPerGroup: Number(this.dataset.responsiveMediumSlidesPerView),
                        spaceBetween: this.dataset.responsiveMediumSpaceBetween,
                    },
                    990: {
                        slidesPerView: Number(this.dataset.responsiveLargeSlidesPerView),
                        slidesPerGroup: Number(this.dataset.responsiveLargeSlidesPerView),
                        spaceBetween: this.dataset.responsiveLargeSpaceBetween,
                    }
                }
            }
            value = {
                ...value,
                ...responsive
            }
        }

        return value;
    }
}

if (!customElements.get('slider-component')) {
    customElements.define('slider-component', SliderComponent);
}